// Enum para los estados de paquete con sus descripciones
export enum PackageStatus {
  PND = 'PND',
  BDL = 'BDL',
  CBD = 'CBD',
  CDG = 'CDG',
  CGS = 'CGS',
  CLS = 'CLS',
  CBK = 'CBK',
  CWB = 'CWB',
  DEC = 'DEC',
  EOP = 'EOP',
  ERS = 'ERS',
  EXL = 'EXL',
  HCA = 'HCA',
  HCE = 'HCE',
  HCM = 'HCM',
  HDC = 'HDC',
  HDR = 'HDR',
  HNR = 'HNR',
  HTC = 'HTC',
  NRC = 'NRC',
  OTN = 'OTN',
  REO = 'REO',
  RGR = 'RGR',
  RGS = 'RGS',
  SIN = 'SIN',
  SWB = 'SWB',
  TRN = 'TRN',
  WHU = 'WHU'
}

// Mapeo de estados con sus descripciones completas
export const PACKAGE_STATUS_DESCRIPTIONS: Record<PackageStatus, string> = {
  [PackageStatus.PND]: 'Pendiente - Estado por defecto si no se ha creado la guía',
  [PackageStatus.BDL]: 'Entregada en Sucursal - Mercancía entregada en modalidad "ocurre". Cliente destinatario acude a sucursal Paquetexpress a recoger su paquetería.',
  [PackageStatus.CBD]: 'Cancelación de Entrega - Cancelación de entrega ocurre',
  [PackageStatus.CDG]: 'Cancelación extemporánea (daño) - Estatus interno para cancelación extemporánea (daño)',
  [PackageStatus.CGS]: 'Cancelación extemporánea (no enviado) - Estatus interno para cancelación extemporánea (Mercancía no enviada)',
  [PackageStatus.CLS]: 'Cancelación extemporánea (extravío) - Estatus interno para cancelación extemporánea (Extravío)',
  [PackageStatus.CBK]: 'Guia Cancelada Documentación Web - Cancelación de guía en WMS Paquetexpress (con recolección efectuada)',
  [PackageStatus.CWB]: 'Guia Cancelada Documentación Web - Cancelación de guía electrónica (sin recolección efectuada)',
  [PackageStatus.DEC]: 'Cancelación (Decomisos) - Estatus interno para cancelación extemporánea (decomiso por autoridad)',
  [PackageStatus.EOP]: 'Cancelación extemporánea (error operativo) - Estatus interno para cancelación extemporánea (error operativo)',
  [PackageStatus.ERS]: 'Cancelación extemporánea (error sistema) - Estatus interno para cancelación extemporánea (error en sistema)',
  [PackageStatus.EXL]: 'Excepción Centralizada - Estatus interno para eventualidades extemporánea',
  [PackageStatus.HCA]: 'Confirmación de recolección en almacen - Llegada de mercancía recién recolectada, al almacén orígen Paquetexpress',
  [PackageStatus.HCE]: 'Cancelación de EAD - Mercancía entregada a domicilio en dispositivo PDA por error, que posteriormente se revierte dicha entrega en mismo dispositivo.',
  [PackageStatus.HCM]: 'Recolección Realizada - Mercancía escaneada para recolección en instalaciones de cliente, con dispositivo PDA de Paquetexpress',
  [PackageStatus.HDC]: 'Mercancía Entregada a Domicilio - Mercancía entregada en domicilio de cliente destinatario.',
  [PackageStatus.HDR]: 'Devolución EAD - Mercancía no entregada en domicilio de destinatario.',
  [PackageStatus.HNR]: 'RAD No Realizada - Estatus indicativo para una visita no efectuada, planeada en proceso de recolección',
  [PackageStatus.HTC]: 'En ruta de entrega a domicilio - Salida de móvil de entrega, de almacen Paquetexpress hacia los domicilios de destinatarios para entrega de paquetes.',
  [PackageStatus.NRC]: 'No Recibida - Mercancía no escaneada en proceso de llegada a almacén Paquetexpress destino',
  [PackageStatus.OTN]: 'EAD Entrega a operador logístico Nacional - Mercancía entregada a operador logístico nacional para apoyo en entrega a domicilio, para zonas alejadas de ciudad.',
  [PackageStatus.REO]: 'Retención Ocurre - Escaneo para entrega ocurre, en una sucursal Paquetexpress que no es el destino de la mercancía, pero que pertenece a la misma plaza.',
  [PackageStatus.RGR]: 'Solicitud de devolución (retorno) - Solicitud de devolución a dirección orígen del envío',
  [PackageStatus.RGS]: 'Reexpedición de mercancía - Solicitud de reexpedición de mercancía hacia otra ciudad',
  [PackageStatus.SIN]: 'Cancelación (Siniestros) - Estatus interno para cancelación extemporánea (Siniestro)',
  [PackageStatus.SWB]: 'Documentación de Servicios WEB - Estatus inicial de documentación, para guías generadas de manera electrónica (Webservices)',
  [PackageStatus.TRN]: 'Mercancía en Tránsito - La mercancía empieza a viajar entre centros de distribución Paquetexpress de distintas ciudades.',
  [PackageStatus.WHU]: 'Recibida en Sucursal - La mercancía llega a un centro de distribución Paquetexpress, que puede ser también el almacén logístico destino.'
};

export const PACKAGE_STATUS_ABREVIATIONS: Record<PackageStatus, string> = {
  [PackageStatus.PND]: 'Pendiente',
  [PackageStatus.BDL]: 'Entregada sucursal',
  [PackageStatus.CBD]: 'Cancelación entrega',
  [PackageStatus.CDG]: 'Cancelación daño',
  [PackageStatus.CGS]: 'Cancelación no enviado',
  [PackageStatus.CLS]: 'Cancelación extravío',
  [PackageStatus.CBK]: 'Guia Cancelada',
  [PackageStatus.CWB]: 'Cancelada ',
  [PackageStatus.DEC]: 'Cancelación decomisos',
  [PackageStatus.EOP]: 'Cancelación error operativo',
  [PackageStatus.ERS]: 'Cancelación error sistema',
  [PackageStatus.EXL]: 'Excepción',
  [PackageStatus.HCA]: 'Recolección almacen',
  [PackageStatus.HCE]: 'Cancelación EAD',
  [PackageStatus.HCM]: 'Recolección realizada',
  [PackageStatus.HDC]: 'Entregada',
  [PackageStatus.HDR]: 'Devolución EAD',
  [PackageStatus.HNR]: 'RAD No Realizada',
  [PackageStatus.HTC]: 'En ruta de entrega',
  [PackageStatus.NRC]: 'No Recibida',
  [PackageStatus.OTN]: 'EAD Entrega a operador',
  [PackageStatus.REO]: 'Retención Ocurre',
  [PackageStatus.RGR]: 'Devolución retorno',
  [PackageStatus.RGS]: 'Reexpedición de mercancía',
  [PackageStatus.SIN]: 'Cancelación siniestros',
  [PackageStatus.SWB]: 'Guia creada',
  [PackageStatus.TRN]: 'En tránsito',
  [PackageStatus.WHU]: 'Recibida sucursal'
};

export interface Delivery {
  ENTREGA: string;
  PEDIDO: string;
  DESTINATARIO: string;
  REFERENCIA: string;
  NOMBRE_CLIENTE1: string;
  CELULAR: string
  IDSAP: string;
  RECOLECCION_FECHA: string | null;
  SALIDA_FECHA: string | null;
  ENTREGA_FECHA: string | null;
  NUMERO_RASTREO: string | null;
  CANTIDAD_BULTOS: string;
  PESO_TOTAL: number;
  ESTADO: string | null;
  ESTADO_PAQUETE: string;
  CREADO: string;
  ACTUALIZACION_FECHA: string;
}

export interface DateRangeParams {
  startDate: string;
  endDate: string;
  status?: string;
} 